module.exports = __webpack_public_path__ + "img/bgR1.5956cdd1.png";